import { useSelector } from "react-redux";
import PhotoAction from "@common/redux/actions/PhotoAction";
import IdentityFormModalAction from "@common/redux/actions/IdentityFormModalAction";
import { addBase64Prefix, getLatestImage } from "../helpers/image";

const usePhoto = () => {
  const data = useSelector((state) => PhotoAction.getStatePath(state));

  const identityData = useSelector((state) =>
    IdentityFormModalAction.getStatePath(state),
  );

  const setPhotoState = (state) => PhotoAction.dispatch(state);

  const toggleCamera = (showCamera) => setPhotoState({ showCamera });

  const toggleCropper = (showCropper) => setPhotoState({ showCropper });

  const onSavePhoto = (photo) => {
    toggleCamera(false);
    setPhotoState({ photo, updatePhoto: true });
  };

  const onResetPhoto = () => {
    setPhotoState({ photo: null });
  };

  const getImage = (customer, imageType) => {
    const photo = addBase64Prefix(getLatestImage(customer, imageType)?.image);
    return photo;
  };

  const getPhoto = (customer) => getImage(customer, "Detail");

  const getThumbnail = (customer) => getImage(customer, "Thumbnail");

  return {
    ...data,
    ...identityData,
    setPhotoState,
    toggleCamera,
    toggleCropper,
    onSavePhoto,
    onResetPhoto,
    getImage,
    getPhoto,
    getThumbnail,
  };
};

export default usePhoto;
